import type { IosKeyboardAdjustmentOptions } from './use-ios-keyboard-adjustment.app';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useIosKeyboardAdjustment = (_: IosKeyboardAdjustmentOptions = {}) => {};
